/**
 * v2 (26/10/2026) — the campaign groups a paste can land in, for any country: its plan's groups
 * and its catalog's, as the board's switcher lists them (never the copied group itself), and the
 * one the copy picks by itself — its twin by name, the country prefix left out
 * ("AU_CASINO_MAINFLOW" → "CZ_CASINO_MAINFLOW"); none when no group has that name.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useMemo } from 'react';

import { type GroupEntry, groupEntries } from '@/features/drop-generator/components/campaign/campaign-scope';
import { useCampaignGroups } from '@/features/drop-generator/components/campaign/use-campaign-groups';
import { useCampaignPins } from '@/features/drop-generator/components/campaign/use-campaign-pins';
import type { GroupCopyClip } from '@/features/drop-generator/components/group-copy/clipboard/group-copy-clipboard';
import { usePlan } from '@/features/drop-generator/useDropGenerator';

export { twinGroup } from '@/features/drop-generator/components/group-copy/dialog/model/paste-summary';

export function useCountryGroups(countryKey: string, clip: GroupCopyClip): { groups: GroupEntry[]; loaded: boolean; failed: boolean } {
  const plan = usePlan(countryKey);
  const ix = useCampaignGroups(countryKey);
  const pins = useCampaignPins(countryKey);
  const groups = useMemo(() => {
    if (!plan.data) return [];
    const all = groupEntries(plan.data, ix, pins.pinned);
    return clip.source.countryKey === countryKey ? all.filter((g) => g.key !== clip.source.groupKey) : all;
  }, [plan.data, ix, pins.pinned, clip.source, countryKey]);
  return { groups, loaded: Boolean(plan.data) && ix.loaded, failed: plan.isError };
}
